import { Box, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContainedButton } from 'components/ContainedButton';
import { useGeneralChargesContext } from 'contexts/GeneralChargesContext';
import { cdLetters, hudNumbers } from '../../utils';
import { getChargeTabLabel, getChargesTabs } from '../ChargesTabs/utils';
import { GeneralTableCharges } from '../GeneralChargesTable';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontSize: '1.1rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
    padding: theme.spacing(1.5, 1.5, 0),
  },
  titleAction: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 1.5, 0),
  },
}));

interface Props {
  currentChargeTabSelected: string;
  orderType: string;
  transactionType: string;
}

export const ChargesGeneralTabContent: FC<Props> = ({
  currentChargeTabSelected,
  orderType,
  transactionType,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { updateModalState } = useGeneralChargesContext();
  const isMobile = !useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
  const currentTab = getChargesTabs({ orderType, transactionType })
    .find((tab) => tab.code === currentChargeTabSelected);
  const currentLabel = currentTab ? getChargeTabLabel(t, currentTab) : undefined;
  const showAddDocument = ['E', '1200'].includes(currentChargeTabSelected);

  return (
    <>
      {cdLetters.concat(hudNumbers).includes(currentChargeTabSelected) && (
        <Box>
          {isMobile && currentLabel && (
            <Typography className={classes.title}>{currentLabel}</Typography>
          )}
          {showAddDocument && !isMobile && (
            <Box className={classes.titleAction}>
              <ContainedButton
                text={t('accounting:add-document-entry')}
                size="small"
                onClick={() => {
                  updateModalState({ modal: 'addDocument', charge: undefined, rowIndex: undefined });
                }}
              />
            </Box>
          )}
          <GeneralTableCharges orderType={orderType} />
        </Box>
      )}
    </>
  );
};
